import { render, staticRenderFns } from "./AdminPoemView.vue?vue&type=template&id=a4440fc6&scoped=true&"
import script from "./AdminPoemView.vue?vue&type=script&lang=js&"
export * from "./AdminPoemView.vue?vue&type=script&lang=js&"
import style0 from "./AdminPoemView.vue?vue&type=style&index=0&id=a4440fc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4440fc6",
  null
  
)

export default component.exports